// const BOT_BASE_URL = "http://localhost:8000/"
const BOT_BASE_URL = 'https://bot.abanprime.com/'
// const API_URL = 'http://localhost:4040'
const API_URL = process.env.VUE_APP_API_URL ?? 'https://api.abanprime.com'
const PRODUCT = process.env.VUE_APP_PRODUCT ?? 'prime'
const PRODUCT_TITLE = process.env.VUE_APP_PRODUCT_TITLE ?? 'Aban Prime'
const PRODUCT_WEBSITE = process.env.VUE_APP_PRODUCT_WEBSITE ?? 'AbanPrime.com'
export default { API_URL, BOT_BASE_URL, PRODUCT_TITLE, PRODUCT_WEBSITE, PRODUCT }
